export const fmtMoney = (n) => {
    if (n === null || n === undefined) return "PKR 0.00";
    return new Intl.NumberFormat('en-PK', { style: 'currency', currency: 'PKR' }).format(n);
  };
  
  export const pillCls = (status) => {
    status = (status || "").toLowerCase();
    if (status.includes("draft")) return "pill-draft";
    if (status.includes("open")) return "pill-open";
    if (status.includes("paid")) return "pill-paid";
    if (status.includes("posted")) return "pill-posted";
    if (status.includes("active")) return "pill-asset";
    return "pill-draft";
  };
  
  export const computeTotals = (doc) => {
    const sub = (doc.lines||[]).reduce((s,l)=> s + Number(l.qty||0)*Number(l.price||0), 0);
    const tax = (doc.lines||[]).reduce((s,l)=> s + Number(l.qty||0)*Number(l.price||0)*Number(l.tax||0), 0);
    const total = sub + tax;
    return {sub, tax, total};
  };
  
  export const allocatedAmount = (kind, docNo) => {
    if (kind === 'vendor') {
      return DB.vendor_payments.flatMap(p => p.allocated || []).filter(a => a.doc === docNo).reduce((s, a) => s + Number(a.amount || 0), 0);
    } else {
      return DB.customer_receipts.flatMap(p => p.allocated || []).filter(a => a.doc === docNo).reduce((s, a) => s + Number(a.amount || 0), 0);
    }
  };
  
  // Enhanced Database with all modules
  export const DB = {
    coa: [
      {code:'100000', name:'Cash on Hand', type:'Asset', parent:'', tags:['cash'], reconcile:true, deprecated:false, balance:120000},
      {code:'110000', name:'HBL Bank Account', type:'Asset', parent:'', tags:['bank'], reconcile:true, deprecated:false, balance:540000},
      {code:'120000', name:'Accounts Receivable', type:'Asset', parent:'', tags:['receivable'], reconcile:true, deprecated:false, balance:210000},
      {code:'200000', name:'Accounts Payable', type:'Liability', parent:'', tags:['payable'], reconcile:true, deprecated:false, balance:155000},
      {code:'300000', name:'Share Capital', type:'Equity', parent:'', tags:[], reconcile:false, deprecated:false, balance:400000},
      {code:'400000', name:'Sales Revenue', type:'Income', parent:'', tags:[], reconcile:false, deprecated:false, balance:980000},
      {code:'500000', name:'Cost of Goods Sold', type:'Expense', parent:'', tags:[], reconcile:false, deprecated:false, balance:620000},
      {code:'510000', name:'Salaries and Wages', type:'Expense', parent:'', tags:[], reconcile:false, deprecated:false, balance:150000},
    ],
    vendors: [
      {code:'VEND-001', name:'Alpha Supplies', is_company:true, street:'12 Supply Rd', city:'Lahore', state:'Punjab', country:'PK', phone:'0300-0001111', email:'alpha@supplies.com', terms:'30 days', currency:'PKR', payable_acc:'200000', purchase_tax:'GST 18%', notes:'Preferred vendor for stationery', chatter:[]},
      {code:'VEND-002', name:'Beta Traders', is_company:true, street:'88 Market Ave', city:'Islamabad', state:'ICT', country:'PK', phone:'0300-0002222', email:'beta@traders.com', terms:'15 days', currency:'PKR', payable_acc:'200000', purchase_tax:'GST 18%', notes:'Good for bulk orders', chatter:[]},
      {code:'VEND-003', name:'Gamma IT Solutions', is_company:true, street:'42 Tech Park', city:'Karachi', state:'Sindh', country:'PK', phone:'0300-0003333', email:'gamma@itsolutions.com', terms:'45 days', currency:'PKR', payable_acc:'200000', purchase_tax:'GST 18%', notes:'Hardware and software vendor', chatter:[]},
    ],
    customers: [
      {code:'CUST-100', name:'Acme Pvt.', is_company:true, street:'1 Main St', city:'Lahore', state:'Punjab', country:'PK', phone:'042-111-222', email:'ap@acme.com', terms:'15 days', currency:'PKR', receivable_acc:'120000', sales_tax:'GST 18%', notes:'VIP client, high volume', chatter:[]},
      {code:'CUST-200', name:'Globex LLC', is_company:true, street:'9 Queens Rd', city:'Karachi', state:'Sindh', country:'PK', phone:'021-123-456', email:'ar@globex.com', terms:'30 days', currency:'PKR', receivable_acc:'120000', sales_tax:'GST 18%', notes:'Requires detailed invoicing', chatter:[]},
      {code:'CUST-300', name:'Initech Corp', is_company:true, street:'3 Corporate Blvd', city:'Islamabad', state:'ICT', country:'PK', phone:'051-987-654', email:'accounts@initech.com', terms:'30 days', currency:'PKR', receivable_acc:'120000', sales_tax:'GST 18%', notes:'', chatter:[]},
    ],
    vendor_bills: [
      {number:'BILL-1001', vendor:'Alpha Supplies', date:'2025-01-05', due:'2025-02-05', lines:[{desc:'Notebooks A4', qty:100, price:200, tax:0.18}], status:'Paid', chatter:[]},
      {number:'BILL-1002', vendor:'Beta Traders', date:'2025-01-12', due:'2025-02-12', lines:[{desc:'Whiteboard Markers', qty:50, price:150, tax:0.18}], status:'Open', chatter:[]},
      {number:'BILL-1003', vendor:'Gamma IT Solutions', date:'2025-01-15', due:'2025-03-01', lines:[{desc:'Annual Software License', qty:1, price:50000, tax:0.18}], status:'Open', chatter:[]},
    ],
    vendor_payments: [
      {number:'PAY-5001', vendor:'Alpha Supplies', date:'2025-01-20', method:'Bank', amount:23600, allocated:[{doc:'BILL-1001', amount:23600}], status:'Posted', chatter:[]},
    ],
    customer_invoices: [
      {number:'INV-0001', customer:'Acme Pvt.', date:'2025-01-10', due:'2025-01-25', lines:[{desc:'Consulting Services - Jan', qty:1, price:150000, tax:0.0}], status:'Paid', chatter:[]},
      {number:'INV-0002', customer:'Globex LLC', date:'2025-01-14', due:'2025-02-13', lines:[{desc:'Stationery Pack', qty:10, price:8800, tax:0.18}], status:'Open', chatter:[]},
      {number:'INV-0003', customer:'Initech Corp', date:'2025-01-18', due:'2025-02-17', lines:[{desc:'Custom Development Work', qty:20, price:5000, tax:0.18}], status:'Draft', chatter:[]},
    ],
    customer_receipts: [
      {number:'RCPT-7001', customer:'Acme Pvt.', date:'2025-01-22', method:'Cash', amount:150000, allocated:[{doc:'INV-0001', amount:150000}], status:'Posted', chatter:[]},
    ],
    credit_notes: [
      {number:'CN-9001', partner:'Globex LLC', date:'2025-01-26', ref:'INV-0002', lines:[{desc:'Goodwill Discount', qty:1, price:-5000, tax:0}], status:'Posted', chatter:[]},
    ],
    debit_notes: [
      {number:'DN-9101', partner:'Beta Traders', date:'2025-01-27', ref:'BILL-1002', lines:[{desc:'Damaged Goods Return', qty:1, price:-1500, tax:0.18}], status:'Posted', chatter:[]},
    ],
    fixed_assets: [
      {code:'FA-001', name:'Laptop Dell XPS 15', category:'IT Equipment', location:'HQ Office', purchase_date:'2024-10-01', cost:280000, life:36, salvage:20000, method:'Straight Line', start_dep:'2024-11-01', status:'Active', chatter:[]},
      {code:'FA-002', name:'Executive Office Desk', category:'Furniture', location:'Director Room', purchase_date:'2024-09-10', cost:150000, life:60, salvage:10000, method:'Straight Line', start_dep:'2024-10-01', status:'Active', chatter:[]}
    ],
    journal_entries: [
      {date:'2025-01-03', journal:'Bank', reference:'PAY-5001', account:'200000', partner:'Alpha Supplies', label:'Vendor Payment', debit:0, credit:23600},
      {date:'2025-01-10', journal:'Sales', reference:'INV-0001', account:'400000', partner:'Acme Pvt.', label:'Consulting Services - Jan', debit:0, credit:150000},
      {date:'2025-01-10', journal:'Sales', reference:'INV-0001', account:'120000', partner:'Acme Pvt.', label:'Consulting Services - Jan', debit:150000, credit:0},
      {date:'2025-01-22', journal:'Cash', reference:'RCPT-7001', account:'100000', partner:'Acme Pvt.', label:'Customer Receipt', debit:150000, credit:0},
    ],
    bank_reconciliation: [
      {date:'2025-01-31', bank:'HBL Bank Account', statement:'Jan-2025', amount:5000, status:'Unreconciled', description: 'Bank Service Charges'},
      {date:'2025-01-31', bank:'HBL Bank Account', statement:'Jan-2025', amount:-1200, status:'Unreconciled', description: 'Late Fee Reversal'}
    ],
    depreciation_schedule: [
      {asset_code:'FA-001', asset_name: 'Laptop Dell XPS 15', date:'2025-01-31', amount:7222.22, journal_entry:'JE-DEP-001', status:'Posted'},
      {asset_code:'FA-002', asset_name: 'Executive Office Desk', date:'2025-01-31', amount:2333.33, journal_entry:'JE-DEP-002', status:'Posted'},
    ],
    asset_disposal: [
        {asset_code:'FA-003', asset_name: 'Old Printer HP', disposal_date:'2025-01-15', method:'Scrapped', proceeds:0, gain_loss:-5000, status:'Completed'}
    ],
    inv_products: [
      {code:'PROD-001', name:'Notebook A4', category:'Stationery', unit:'Piece', cost:250, price:350, stock:500, location:'Warehouse A'},
      {code:'PROD-002', name:'Pen Blue', category:'Stationery', unit:'Piece', cost:15, price:25, stock:1000, location:'Warehouse A'},
      {code:'PROD-003', name:'Keyboard Wireless', category:'IT Accessories', unit:'Piece', cost:2500, price:3500, stock:50, location:'Warehouse B'},
    ],
    inv_transfer: [
      {number:'TRF-001', date:'2025-01-15', from:'Warehouse A', to:'Warehouse B', product:'Notebook A4', qty:50, status:'Completed'},
      {number:'TRF-002', date:'2025-01-18', from:'Warehouse B', to:'Main Shop', product:'Pen Blue', qty:100, status:'Pending'}
    ],
    inv_issuance: [
      {number:'ISS-001', date:'2025-01-20', product:'Notebook A4', qty:25, purpose:'Office Use', department:'Admin', status:'Issued'},
      {number:'ISS-002', date:'2025-01-22', product:'Pen Blue', qty:50, purpose:'Marketing Event', department:'Marketing', status:'Issued'}
    ],
    inv_receipt: [
      {number:'RCP-001', date:'2025-01-12', product:'Notebook A4', qty:100, supplier:'Alpha Supplies', rate:250, total:25000, status:'Received'},
      {number:'RCP-002', date:'2025-01-14', product:'Pen Blue', qty:200, supplier:'Beta Traders', rate:15, total:3000, status:'Received'}
    ],
    inv_warehouse: [
      {code:'WH-A', name:'Main Warehouse', location:'Main Building', capacity:10000, current_stock:8500, manager:'John Doe'},
      {code:'WH-B', name:'Annex Warehouse', location:'Annex Building', capacity:5000, current_stock:3200, manager:'Jane Smith'}
    ],
    inv_bom: [
      {code:'BOM-001', product:'Student Stationery Set', components:[{item:'Notebook A4', qty:5}, {item:'Pen Blue', qty:10}], cost:1400, status:'Active'},
      {code:'BOM-002', product:'Office Starter Pack', components:[{item:'Notebook A4', qty:2}, {item:'Pen Blue', qty:5}], cost:575, status:'Active'}
    ],
    hrm_employee_profile: [
      {emp_code:'EMP-001', name:'Ahmed Ali', department:'Finance', designation:'Accountant', join_date:'2024-01-15', status:'Active', email:'ahmed@company.com', phone:'0300-1111111'},
      {emp_code:'EMP-002', name:'Fatima Khan', department:'HR', designation:'HR Manager', join_date:'2023-06-10', status:'Active', email:'fatima@company.com', phone:'0300-2222222'},
      {emp_code:'EMP-003', name:'Usman Baig', department:'IT', designation:'System Admin', join_date:'2024-03-01', status:'Active', email:'usman@company.com', phone:'0300-3333333'}
    ],
    hrm_benefits: [
      {title:'Medical Allowance', btype:'Benefit', amount:5000, effective:'2024-01-01', status:'Active'},
      {title:'Transport Allowance', btype:'Benefit', amount:3000, effective:'2024-01-01', status:'Active'},
      {title:'Income Tax', btype:'Deduction', amount:8000, effective:'2024-01-01', status:'Active'},
      {title:'Provident Fund', btype:'Deduction', amount:2500, effective:'2024-01-01', status:'Active'}
    ],
    hrm_salary_structure: [
      {code:'SAL-001', title:'Junior Level', grade:'J1', basic:35000, allowances:8000, deductions:3000, active:true},
      {code:'SAL-002', title:'Senior Level', grade:'S1', basic:65000, allowances:15000, deductions:8000, active:true},
      {code:'SAL-003', title:'Manager Level', grade:'M1', basic:90000, allowances:25000, deductions:15000, active:true}
    ],
    hrm_kpis: [
      {employee:'Ahmed Ali', period:'Q1-2025', score:85, manager:'Finance Director', status:'Approved'},
      {employee:'Fatima Khan', period:'Q1-2025', score:92, manager:'CEO', status:'Approved'}
    ],
    config_journal: [
      {code:'SALES', name:'Sales Journal', type:'Sales', account:'400000', status:'Active'},
      {code:'PURCHASE', name:'Purchase Journal', type:'Purchase', account:'500000', status:'Active'},
      {code:'CASH', name:'Cash Journal', type:'Cash', account:'100000', status:'Active'},
      {code:'BANK', name:'Bank Journal', type:'Bank', account:'110000', status:'Active'}
    ],
    config_fin_dims: [
      {code:'DEPT', name:'Department', values:['Finance', 'HR', 'Admin', 'Academic', 'IT'], status:'Active'},
      {code:'PROJ', name:'Project', values:['Project Alpha', 'Project Beta', 'Internal'], status:'Active'}
    ]
  };
  
  // Module configurations matching the HTML structure exactly
  export const Modules = {
    coa: {
      title:'Chart of Accounts',
      subtitle:'Master list of accounts for your ledger.',
      type:'table',
      columns:[
        {accessorKey:'code', header:'Code', size: 100},
        {accessorKey:'name', header:'Account Name', size: 200},
        {accessorKey:'type', header:'Type', size: 100},
        {accessorKey:'parent', header:'Parent', size: 120},
        {accessorKey:'tags', header:'Tags', size: 120, Cell: ({cell}) => (cell.getValue() || []).map(t => `${t}`).join(', ')},
        {accessorKey:'reconcile', header:'Reconcile', size: 100, Cell: ({cell}) => cell.getValue() ? 'Yes' : 'No'},
        {accessorKey:'deprecated', header:'Deprecated', size: 100, Cell: ({cell}) => cell.getValue() ? 'Yes' : 'No'},
        {accessorKey:'balance', header:'Balance', size: 120, Cell: ({cell}) => fmtMoney(cell.getValue())}
      ],
      formTabs:[
        {name:'General', fields:[
          {key:'code', label:'Code', col:4, required: true},
          {key:'name', label:'Account Name', col:8, required: true},
          {key:'type', label:'Type', type:'select', options:['Asset','Liability','Equity','Income','Expense'], col:4, required: true},
          {key:'parent', label:'Parent', col:4},
          {key:'balance', label:'Opening Balance', type:'number', col:4},
        ]},
        {name:'Configuration', fields:[
          {key:'reconcile', label:'Allow Reconciliation', type:'checkbox', col:4},
          {key:'deprecated', label:'Deprecated', type:'checkbox', col:4},
          {key:'tags', label:'Tags (comma separated)', placeholder:'cash, bank', col:8},
        ]},
        {name:'Notes', fields:[
          {key:'notes', label:'Internal Notes', type:'textarea', col:12}
        ]}
      ]
    },
    vendors: {
      title:'Vendors',
      subtitle:'Create and manage vendor profiles.',
      type:'table',
      columns:[
        {accessorKey:'code', header:'Code', size: 100},
        {accessorKey:'name', header:'Vendor Name', size: 200},
        {accessorKey:'city', header:'City', size: 100},
        {accessorKey:'phone', header:'Phone', size: 120},
        {accessorKey:'email', header:'Email', size: 150},
        {accessorKey:'terms', header:'Payment Terms', size: 120}
      ],
      formTabs:[
        {name:'Vendor Information', fields:[
          {key:'code', label:'Vendor Code', col:4, required: true},
          {key:'name', label:'Vendor / Legal Name', col:8, required: true},
          {key:'short_name', label:'Short Name', col:4},
          {key:'type', label:'Type', type:'select', options:['Company','Individual'], col:4},
          {key:'status', label:'Status', type:'select', options:['Active','Inactive'], col:4},
          {key:'email', label:'Primary Email', type:'email', col:6},
          {key:'phone', label:'Primary Phone', col:6},
          {key:'country', label:'Country', type:'select', options:['Pakistan','India','UAE','USA','Other'], col:4},
          {key:'city', label:'City', col:4},
          {key:'address', label:'Address', type:'textarea', col:12},
          {key:'terms', label:'Payment Terms', type:'select', options:['Due on Receipt','15 Days','30 Days','45 Days'], col:4},
          {key:'currency', label:'Preferred Currency', type:'select', options:['PKR','USD','EUR','GBP'], col:4},
          {key:'category', label:'Category', type:'select', options:['Stationery','IT','Services','Other'], col:4},
          {key:'website', label:'Website', col:6},
          {key:'vendor_since', label:'Vendor Since', type:'date', col:6}
        ]},
        {name:'Contacts', fields:[
          {key:'street', label:'Street', col:6},
          {key:'city', label:'City', col:3},
          {key:'state', label:'State', col:3},
          {key:'country', label:'Country', col:3},
          {key:'contact_person', label:'Contact Person', col:5},
          {key:'contact_phone', label:'Contact Phone', col:4},
          {key:'contact_email', label:'Contact Email', type:'email', col:6}
        ]},
        {name:'Banking', fields:[
          {key:'bank_name', label:'Bank Name', col:6},
          {key:'bank_account', label:'Account Number', col:6},
          {key:'iban', label:'IBAN', col:6},
          {key:'branch', label:'Branch', col:6},
          {key:'swift', label:'SWIFT/BIC', col:6}
        ]},
        {name:'Tax & Compliance', fields:[
          {key:'purchase_tax', label:'Default Purchase Tax', col:4},
          {key:'tax_ntn', label:'NTN', col:4},
          {key:'tax_strn', label:'STRN', col:4},
          {key:'tax_reg', label:'Tax Registration Type', col:6}
        ]},
        {name:'Documents', fields:[
          {key:'doc_cr', label:'Company Reg / CR', type:'text', placeholder:'Link or reference', col:6},
          {key:'doc_tax', label:'Tax Certificate', type:'text', placeholder:'Link or reference', col:6},
          {key:'attachments', label:'Attachments / Notes', type:'textarea', col:12}
        ]},
        {name:'Ledger Record', fields:[
          {key:'payable_acc', label:'Payable Account', col:6},
          {key:'opening_balance', label:'Opening Balance', type:'number', col:6}
        ]},
        {name:'Customize Fields', fields:[
          {key:'custom1', label:'Custom Field 1', col:6},
          {key:'custom2', label:'Custom Field 2', col:6},
          {key:'custom3', label:'Custom Field 3', col:6},
          {key:'notes', label:'Internal Notes', type:'textarea', col:12}
        ]}
      ]
    },
    customers: {
      title:'Customers',
      subtitle:'Create and manage customer profiles.',
      type:'table',
      columns:[
        {accessorKey:'code', header:'Code', size: 100},
        {accessorKey:'name', header:'Customer Name', size: 200},
        {accessorKey:'city', header:'City', size: 100},
        {accessorKey:'phone', header:'Phone', size: 120},
        {accessorKey:'email', header:'Email', size: 150},
        {accessorKey:'terms', header:'Payment Terms', size: 120}
      ],
      formTabs:[
        {name:'General', fields:[
          {key:'code', label:'Code', col:4, required: true},
          {key:'name', label:'Customer Name', col:8, required: true},
          {key:'is_company', label:'Is a Company', type:'checkbox', col:3},
          {key:'phone', label:'Phone', col:3},
          {key:'email', label:'Email', type:'email', col:6},
        ]},
        {name:'Addresses', fields:[
          {key:'street', label:'Street', col:6},
          {key:'city', label:'City', col:3},
          {key:'state', label:'State', col:3},
          {key:'country', label:'Country', col:3},
        ]},
        {name:'Sales & Purchases', fields:[
          {key:'terms', label:'Payment Terms', col:4},
          {key:'currency', label:'Currency', col:4},
          {key:'sales_tax', label:'Default Sales Tax', col:4},
        ]},
        {name:'Accounting', fields:[
          {key:'receivable_acc', label:'Receivable Account', col:6},
        ]},
        {name:'Notes', fields:[
          {key:'notes', label:'Internal Notes', type:'textarea', col:12}
        ]}
      ]
    },
    vendor_bills: {
      title:'Vendor Bills',
      subtitle:'Vendor invoices awaiting payment.',
      type:'doc',
      docCfg: { partnerKey:'vendor', partnerList:()=>DB.vendors.map(v=>v.name) },
    },
    customer_invoices: {
      title:'Customer Invoices',
      subtitle:'Invoices issued to customers.',
      type:'doc',
      docCfg: { partnerKey:'customer', partnerList:()=>DB.customers.map(c=>c.name) },
    },
    vendor_payments: {
      title:'Vendor Payments',
      subtitle:'Record payments to vendors and allocate to bills.',
      type:'table',  // Change to table
      columns:[
        {accessorKey:'number', header:'Payment #', size: 120},
        {accessorKey:'vendor', header:'Vendor', size: 200},
        {accessorKey:'date', header:'Date', size: 120},
        {accessorKey:'method', header:'Method', size: 100},
        {accessorKey:'amount', header:'Amount', size: 120, Cell: ({cell}) => fmtMoney(cell.getValue())},
        {accessorKey:'status', header:'Status', size: 100, Cell: ({cell}) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span>}
      ],
      formTabs:[
        {name:'Payment', fields:[
          {key:'number', label:'Payment Number', col:4, required: true},
          {key:'vendor', label:'Vendor', col:8, required: true},
          {key:'date', label:'Payment Date', type:'date', col:4, required: true},
          {key:'method', label:'Payment Method', type:'select', options:['Cash','Bank','Cheque'], col:4},
          {key:'amount', label:'Amount', type:'number', col:4, required: true},
          {key:'status', label:'Status', type:'select', options:['Draft','Posted'], col:4}
        ]}
      ]
    },
    customer_receipts: {
      title:'Customer Receipts',
      subtitle:'Record incoming payments and allocate to invoices.',
      type:'table',  // Change to table
      columns:[
        {accessorKey:'number', header:'Receipt #', size: 120},
        {accessorKey:'customer', header:'Customer', size: 200},
        {accessorKey:'date', header:'Date', size: 120},
        {accessorKey:'method', header:'Method', size: 100},
        {accessorKey:'amount', header:'Amount', size: 120, Cell: ({cell}) => fmtMoney(cell.getValue())},
        {accessorKey:'status', header:'Status', size: 100, Cell: ({cell}) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span>}
      ],
      formTabs:[
        {name:'Receipt', fields:[
          {key:'number', label:'Receipt Number', col:4, required: true},
          {key:'customer', label:'Customer', col:8, required: true},
          {key:'date', label:'Receipt Date', type:'date', col:4, required: true},
          {key:'method', label:'Payment Method', type:'select', options:['Cash','Bank','Cheque'], col:4},
          {key:'amount', label:'Amount', type:'number', col:4, required: true},
          {key:'status', label:'Status', type:'select', options:['Draft','Posted'], col:4}
        ]}
      ]
    },
    credit_notes: {
      title:'Credit Notes',
      subtitle:'Credits issued to customers.',
      type:'doc',
      docCfg: { partnerKey:'partner', partnerList:()=>DB.customers.map(c=>c.name), refList:()=>DB.customer_invoices.map(i=>i.number) },
    },
    debit_notes: {
      title:'Debit Notes',
      subtitle:'Debits issued to vendors.',
      type:'doc',
      docCfg: { partnerKey:'partner', partnerList:()=>DB.vendors.map(v=>v.name), refList:()=>DB.vendor_bills.map(b=>b.number) },
    },
    fixed_assets: {
      title:'Fixed Assets',
      subtitle:'Register and track assets with useful life and depreciation schedule.',
      type:'asset',
      columns:[
        {accessorKey:'code', header:'Asset Code', size: 100},
        {accessorKey:'name', header:'Asset Name', size: 200},
        {accessorKey:'category', header:'Category', size: 120},
        {accessorKey:'location', header:'Location', size: 100},
        {accessorKey:'purchase_date', header:'Purchase Date', size: 120},
        {accessorKey:'cost', header:'Cost', size: 100, Cell: ({cell}) => fmtMoney(cell.getValue())},
        {accessorKey:'life', header:'Life (months)', size: 100},
        {accessorKey:'status', header:'Status', size: 100}
      ],
      formTabs:[
        {name:'General', fields:[
          {key:'code', label:'Asset Code', col:4, required: true},
          {key:'name', label:'Asset Name', col:8, required: true},
          {key:'category', label:'Category', col:4},
          {key:'location', label:'Location', col:4},
          {key:'purchase_date', label:'Purchase Date', type:'date', col:4},
          {key:'cost', label:'Cost', type:'number', col:3},
          {key:'salvage', label:'Salvage', type:'number', col:3},
          {key:'life', label:'Life (months)', type:'number', col:3},
          {key:'method', label:'Method', type:'select', options:['Straight Line'], col:3},
          {key:'start_dep', label:'Depreciation Start', type:'date', col:4},
          {key:'status', label:'Status', type:'select', options:['Active','Disposed'], col:4}
        ]},
        {name:'Notes', fields:[
          {key:'notes', label:'Internal Notes', type:'textarea', col:12}
        ]}
      ]
    },
      journal_transactions: {
      title: 'Journal Transactions',
      subtitle: 'Detailed log of all financial journal entries.',
      type: 'table',
      columns: [
        { accessorKey: 'date', header: 'Date', size: 100 },
        { accessorKey: 'journal', header: 'Journal', size: 100 },
        { accessorKey: 'reference', header: 'Reference', size: 120 },
        { accessorKey: 'account', header: 'Account', size: 120 },
        { accessorKey: 'partner', header: 'Partner', size: 150 },
        { accessorKey: 'label', header: 'Label', size: 200 },
        { accessorKey: 'debit', header: 'Debit', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'credit', header: 'Credit', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) }
      ],
      formTabs: [
        { name: 'Transaction', fields: [
          { key: 'date', label: 'Date', type: 'date', col: 4, required: true },
          { key: 'journal', label: 'Journal', col: 4, required: true },
          { key: 'reference', label: 'Reference', col: 4 },
          { key: 'account', label: 'Account Code', col: 4, required: true },
          { key: 'partner', label: 'Partner', col: 4 },
          { key: 'label', label: 'Label', col: 12, required: true },
          { key: 'debit', label: 'Debit', type: 'number', col: 6 },
          { key: 'credit', label: 'Credit', type: 'number', col: 6 },
        ]}
      ]
    },
    bank_reconciliation: {
      title: 'Bank Reconciliation',
      subtitle: 'Match bank statements with recorded transactions.',
      type: 'table',
      columns: [
        { accessorKey: 'date', header: 'Date', size: 120 },
        { accessorKey: 'bank', header: 'Bank Account', size: 200 },
        { accessorKey: 'statement', header: 'Statement Ref', size: 150 },
        { accessorKey: 'amount', header: 'Amount', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ],
      formTabs: [
        { name: 'Reconciliation', fields: [
          { key: 'date', label: 'Statement Date', type: 'date', col: 4, required: true },
          { key: 'bank', label: 'Bank Account', col: 8, required: true },
          { key: 'statement', label: 'Statement Reference', col: 6, required: true },
          { key: 'amount', label: 'Statement Line Amount', type: 'number', col: 6, required: true },
          { key: 'description', label: 'Description', col: 12 },
        ]}
      ]
    },
    depreciation_schedule: {
      title: 'Depreciation Schedule',
      subtitle: 'Automated and manual depreciation entries for fixed assets.',
      type: 'table',
      columns: [
        { accessorKey: 'asset_code', header: 'Asset Code', size: 120 },
        { accessorKey: 'asset_name', header: 'Asset Name', size: 200 },
        { accessorKey: 'date', header: 'Date', size: 120 },
        { accessorKey: 'amount', header: 'Amount', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'journal_entry', header: 'Journal Entry', size: 150 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    asset_disposal: {
      title: 'Asset Disposal',
      subtitle: 'Manage the sale, scrapping, or disposal of assets.',
      type: 'table',
      columns: [
        { accessorKey: 'asset_code', header: 'Asset Code', size: 120 },
        { accessorKey: 'asset_name', header: 'Asset Name', size: 200 },
        { accessorKey: 'disposal_date', header: 'Disposal Date', size: 120 },
        { accessorKey: 'method', header: 'Method', size: 120 },
        { accessorKey: 'proceeds', header: 'Proceeds', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'gain_loss', header: 'Gain/Loss', size: 120, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    inv_products: {
      title: 'Products & Services',
      subtitle: 'Manage inventory items, services, and their properties.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'Code', size: 120 },
        { accessorKey: 'name', header: 'Product Name', size: 250 },
        { accessorKey: 'category', header: 'Category', size: 150 },
        { accessorKey: 'cost', header: 'Cost', size: 100, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'price', header: 'Sale Price', size: 100, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'stock', header: 'Stock', size: 80 },
      ]
    },
    inv_transfer: {
      title: 'Inventory Transfers',
      subtitle: 'Move stock between different warehouses or locations.',
      type: 'table',
      columns: [
        { accessorKey: 'number', header: 'Transfer #', size: 120 },
        { accessorKey: 'date', header: 'Date', size: 120 },
        { accessorKey: 'from', header: 'From', size: 150 },
        { accessorKey: 'to', header: 'To', size: 150 },
        { accessorKey: 'product', header: 'Product', size: 200 },
        { accessorKey: 'qty', header: 'Quantity', size: 100 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    inv_issuance: {
      title: 'Inventory Issuance',
      subtitle: 'Issue stock for internal use, projects, or consumption.',
      type: 'table',
      columns: [
        { accessorKey: 'number', header: 'Issuance #', size: 120 },
        { accessorKey: 'date', header: 'Date', size: 120 },
        { accessorKey: 'product', header: 'Product', size: 200 },
        { accessorKey: 'qty', header: 'Quantity', size: 100 },
        { accessorKey: 'department', header: 'Department', size: 150 },
        { accessorKey: 'purpose', header: 'Purpose', size: 200 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    inv_receipt: {
      title: 'Inventory Receipts',
      subtitle: 'Record incoming stock from suppliers or production.',
      type: 'table',
      columns: [
        { accessorKey: 'number', header: 'Receipt #', size: 120 },
        { accessorKey: 'date', header: 'Date', size: 120 },
        { accessorKey: 'product', header: 'Product', size: 200 },
        { accessorKey: 'qty', header: 'Quantity', size: 100 },
        { accessorKey: 'supplier', header: 'Supplier', size: 200 },
        { accessorKey: 'total', header: 'Total Value', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    inv_warehouse: {
      title: 'Warehouses',
      subtitle: 'Manage your physical stock locations.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'Code', size: 100 },
        { accessorKey: 'name', header: 'Warehouse Name', size: 200 },
        { accessorKey: 'location', header: 'Location', size: 200 },
        { accessorKey: 'capacity', header: 'Capacity', size: 120 },
        { accessorKey: 'current_stock', header: 'Current Stock', size: 120 },
        { accessorKey: 'manager', header: 'Manager', size: 150 }
      ]
    },
    inv_bom: {
      title: 'Bill of Materials (BOM)',
      subtitle: 'Define components for manufactured products.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'BOM Code', size: 120 },
        { accessorKey: 'product', header: 'Finished Product', size: 250 },
        { accessorKey: 'cost', header: 'Computed Cost', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    hrm_employee_profile: {
      title: 'Employee Profiles',
      subtitle: 'Central directory for all employee information.',
      type: 'table',
      columns: [
        { accessorKey: 'emp_code', header: 'Emp Code', size: 100 },
        { accessorKey: 'name', header: 'Name', size: 200 },
        { accessorKey: 'department', header: 'Department', size: 150 },
        { accessorKey: 'designation', header: 'Designation', size: 150 },
        { accessorKey: 'join_date', header: 'Join Date', size: 120 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    hrm_benefits: {
      title: 'Benefits & Deductions',
      subtitle: 'Manage salary components like allowances and taxes.',
      type: 'table',
      columns: [
        { accessorKey: 'title', header: 'Title', size: 250 },
        { accessorKey: 'btype', header: 'Type', size: 120 },
        { accessorKey: 'amount', header: 'Amount', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'effective', header: 'Effective Date', size: 150 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    hrm_salary_structure: {
      title: 'Salary Structures',
      subtitle: 'Define salary grades and structures for different roles.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'Code', size: 100 },
        { accessorKey: 'title', header: 'Title', size: 200 },
        { accessorKey: 'grade', header: 'Grade', size: 100 },
        { accessorKey: 'basic', header: 'Basic Salary', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'allowances', header: 'Allowances', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'deductions', header: 'Deductions', size: 150, Cell: ({ cell }) => fmtMoney(cell.getValue()) },
        { accessorKey: 'active', header: 'Active', size: 100, Cell: ({cell}) => cell.getValue() ? 'Yes' : 'No' }
      ]
    },
    hrm_kpis: {
      title: 'KPIs & Appraisals',
      subtitle: 'Track employee performance and key performance indicators.',
      type: 'table',
      columns: [
        { accessorKey: 'employee', header: 'Employee', size: 200 },
        { accessorKey: 'period', header: 'Period', size: 120 },
        { accessorKey: 'score', header: 'Score', size: 100 },
        { accessorKey: 'manager', header: 'Manager', size: 200 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    config_journal: {
      title: 'Journals',
      subtitle: 'Configure different journals for organizing entries.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'Code', size: 120 },
        { accessorKey: 'name', header: 'Journal Name', size: 250 },
        { accessorKey: 'type', header: 'Type', size: 150 },
        { accessorKey: 'account', header: 'Default Account', size: 150 },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    },
    config_fin_dims: {
      title: 'Financial Dimensions',
      subtitle: 'Set up analytical dimensions like departments or projects.',
      type: 'table',
      columns: [
        { accessorKey: 'code', header: 'Code', size: 120 },
        { accessorKey: 'name', header: 'Dimension Name', size: 250 },
        { accessorKey: 'values', header: 'Values', size: 300, Cell: ({ cell }) => (cell.getValue() || []).join(', ') },
        { accessorKey: 'status', header: 'Status', size: 120, Cell: ({ cell }) => <span className={pillCls(cell.getValue())}>{cell.getValue()}</span> }
      ]
    }
  };